import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from "@angular/core";
import { CustomPipesModule } from "@app/_pipes/custom-pipes.module";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { UserMenuComponent } from "../user-menu/user-menu.component";
import { UserAvatarComponent } from "./user-avatar.component";
import { UserAvatarDirective } from "./user-avatar.directive";
import { UserAvatarSizeDirective } from "./user-avatar-size.directive";

@NgModule({
	declarations: [UserAvatarComponent, UserAvatarDirective, UserAvatarSizeDirective],
	imports: [CommonModule, NgxSkeletonLoaderModule, CustomPipesModule],
	exports: [UserAvatarComponent, UserAvatarSizeDirective],
	providers: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserAvatarModule {
	static forRoot(): ModuleWithProviders<UserAvatarModule> {
		return {
			ngModule: UserAvatarModule,
			providers: [],
		};
	}
}
